import { Grid } from '@mui/material';
import { useGetPromptsListQuery } from 'api/services/dataEndpoints';
import PromptItem from '../DataItem/DataItem';

const PromptsList: React.FC = () => {
  const { data } = useGetPromptsListQuery();

  const renderPromptList = () => {
    return data?.map((prompt) => (
        <PromptItem prompt={prompt} key={prompt.id} />
    ));
  };

  return (
  <Grid item xs={12}>
    {renderPromptList()}
  </Grid>
  );
};

export default PromptsList;
